import isEmail from 'validator/lib/isEmail';
import { findAll } from './find';
import { addClass, removeClass } from './helpers';

function validate(form) {
    const rules = {
        text: {
            type: 'text',
            rule: /^\w{1,}$/,
            error: ''
        },
        alpha: {
            type: 'alpha',
            rule: /^[a-zA-Z.-_]{2,}$/,
            error: ''
        },
        email: {
            type: 'email',
            // rule: /^.*@\w{2,}.\w{2,}$/,
            rule: isEmail,
            error: ''
        },
        textarea: {
            type: 'text',
            rule: /^\w{1,}$/,
            error: ''
        }
    };
    let isValid = true;
    const errorAttr = 'data-error';

    const inputs = findAll('input,textarea', form);

    function showUiError(error) {
        if (error && error.style) {
            error.style.display = 'block';
        }
    }

    function hideUiError(error) {
        if (error && error.style) {
            error.style.display = 'none';
        }
    }

    function showError(field, errorType) {
        const errors = findAll(`[${errorAttr}]`, field.parentNode);

        function checkError(error) {
            if (error && error.getAttribute(errorAttr) === errorType) {
                showUiError(error);
            } else {
                hideUiError(error);
            }
        }

        if (errors && errors.length) {
            errors.map(checkError);
        }
    }

    function hideError(field) {
        const selector = `[${errorAttr}]`;
        const errors = findAll(selector, field.parentNode);
        if (errors && errors.length) {
            errors.map(hideUiError);
        }
    }

    function validateFields(field) {
        let errorType = field.getAttribute('data-error-type');

        if (rules[field.type]) {
            let isFieldValid;
            if (field.value.trim().length < 1 || (field.hasOwnProperty('innerText') && field.innerText.trim().length < 1)) {
                errorType = 'required';
                isFieldValid = false;
            } else if (rules[errorType]) {
                if (typeof rules[errorType] === 'function') {
                    isFieldValid = rules[errorType](field.value.trim())
                } else {
                    isFieldValid = rules[errorType].rule.test(field.value.trim());
                }
            } else {
                isFieldValid = true;
            }

            if (!isFieldValid) {
                isValid = false;
                showError(field, errorType);
                addClass(field, 'error');
            } else {
                hideError(field);
                removeClass(field, 'error');
            }
        }
    }

    function filterRequired(input) {
        return input.required;
    }

    const required = inputs.filter(filterRequired);

    required.map(validateFields);
    return isValid;
}

module.exports = validate;



// WEBPACK FOOTER //
// ./src/js/form-validation.js